import React, { Component } from 'react'
import { Form } from 'semantic-ui-react'

export default function Input({ type, formState, tags, options, inputLabel, referenceConfig, size = false, ...props }) {
  let classes = ['form-input', 'form-input--' + type]

  if (size) classes.push(`form-input--size-${size}`)

  return <Form.Input {...props} type={type} className={classes.join(' ')} />
}
